import makeStyles from "@mui/styles/makeStyles";
import { usePapaParse } from 'react-papaparse';
import {AgyleNamedIcon} from "../../../components/icons/agyle";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Select, MenuItem} from "@mui/material";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {setSnackbar} from "../../../store/reducers/globals";
import {useDispatch} from "react-redux";
import {setLoading} from "../../../store/reducers/announcement";
import * as moment from "moment";
import {AdminAPI} from "../admin_api";
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    hiddenInput: {
        display: "none"
    },
    fullWidth: {
        width: "100%",
        borderSpacing: "0px"
    },
    header: {
        backgroundColor: theme.palette.tableHeader.background,
        "& th": {
            padding: "10px 10px 10px 10px"
        }
    },
    tableBody: {
        backgroundColor: theme.palette.tableHeader.background,
        "& tr:nth-child(odd)": {
            backgroundColor : "#ffffff0a"
        },
        "& td": {
            padding: "10px 10px 10px 10px"
        }
    }
}));

export function ImportData(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const { readString } = usePapaParse();
    const [importDialogVisible, setImportDialogVisible] = React.useState(false);
    const [importTableHeaderOptions, setImportTableHeaderOptions] = React.useState([]);
    const [importTableData, setImportTableData] = React.useState([]);
    const [importTableDataField, setImportTableDataField] = React.useState({});
    const [tableName, setTableName] = React.useState("");
    const [tableApi, setTableApi] = React.useState("apiUrl");
    const [tableDisplay, setTableDisplay] = React.useState("");
    const [tableFields, setTableFields] = React.useState([]);

    React.useEffect(()=>{
        if(props.confData){
            if(props.confData.display)  {
                setTableDisplay(props.confData.display);
            }
            if(props.confData.table)  {
                setTableName(props.confData.table);
            }
            if(props.confData.api)  {
                setTableApi(props.confData.api);
            }
            if(props.confData.fields)  {
                setTableFields(props.confData.fields);
                let tmpObj = {};
                props.confData.fields.map((f)=>{
                    tmpObj[f.id] = "";
                });
                setImportTableDataField(tmpObj);
            }
        }
    }, [props.confData])

    const handleCloseImportDialog = () => {
        setImportDialogVisible(false);
        document.getElementById("uploadDocSelect").value = null;
    }

    const prepareRowIdForSave = (row) => {
        if(!row._id) {
            const ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
                s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))
            //console.log("ObjectId",ObjectId());
            row._id = `$objectid(${ObjectId()})`;
        }
        return row;
    }

    const handleImport = () => {
        //console.log("import data please");
        //shows loading
        dispatch(setLoading(true));
        //build row by row according fields config ....
        let promisesRowToImport = [];
        importTableData.map((row) => {
            let iRow = {};
            tableFields.map((field) => {
                switch(field.type){
                    case "date": {
                        try {
                            iRow[field.id] = moment(row[importTableDataField[field.id]]);
                        } catch (ex) {
                            console.error(ex);
                        }
                        break;
                    }
                    case "boolean": {
                        try {
                            iRow[field.id] = _.toLower(row[importTableDataField[field.id]]) === "true";
                        } catch (ex) {
                            console.error(ex);
                        }
                        break;
                    }
                    case "number": {
                        try {
                            if (!_.isEmpty(row[importTableDataField[field.id]])) {
                                iRow[field.id] = Number(row[importTableDataField[field.id]]);
                            }
                        } catch (ex) {
                            console.error(ex);
                        }
                        break;
                    }
                    case "address":
                    case "searchList":
                    case "stringList": {
                        try {
                            iRow[field.id] = JSON.parse(row[importTableDataField[field.id]].replace(/'/g, '"'));
                        } catch (ex) {
                            console.error(ex);
                        }
                        break;
                    }
                    default: {
                        if(row[importTableDataField[field.id]]?.startsWith("{")){
                            try {
                                iRow[field.id] = JSON.parse(row[importTableDataField[field.id]].replace(/'/g, '"'));
                            } catch (ex) {
                                iRow[field.id] = row[importTableDataField[field.id]];
                            }
                        } else {
                            if(field.id === "_id") {
                                // If ID field is empty string then omit field for create new id in mongo
                                if(row[importTableDataField[field.id]] !== "") iRow[field.id] = row[importTableDataField[field.id]];
                            } else {
                                iRow[field.id] = row[importTableDataField[field.id]];
                            }
                        }
                    }
                }
            });
            if(props.confData.table) {
                promisesRowToImport.push(AdminAPI.saveTableRecord(tableName, iRow, tableApi));
            } else {
                promisesRowToImport.push(iRow);
            }
        })
        //save record by record
        //rise event import finished ( on other side - hide loading, dispatch import status)
        if(props.confData.table) {
            Promise.all(promisesRowToImport).then((solveResults) => {
                // let recs = [];
                // solveResults.forEach((saveRes) => {
                //     recs.push(_.cloneDeep(saveRes));
                // });
                //console.log("imported recs", recs);
                if (props.importStatus) {
                    props.importStatus("success");
                    setImportDialogVisible(false);
                }
            })
        } else {
            if(props.confData && props.confData.masterDictionaryTable && props.confData.fieldAsTable) {
                AdminAPI.updateMasterRecordFieldData(props.confData.masterDictionaryTable, props.confData.fieldAsTable, promisesRowToImport, tableApi).then((result) => {
                    // if(typeof result == "object"){
                    //
                    // }
                    if (props.importStatus) {
                        props.importStatus("success");
                        setImportDialogVisible(false);
                    }
                })
            } else {
                if (props.importStatus) {
                    props.importStatus("error");
                    setImportDialogVisible(false);
                }
            }
        }
    }

    const prepareSelect = (id) => {
        return (
            <FormControl fullWidth id={"form_control_" + id}>
                <Select
                    id={"select" + id}
                    value={importTableDataField[id]}
                    onChange={(e) => handleSelectChange(id, e.target.value)}
                >
                    {importTableHeaderOptions.map((option, index) => {
                        return (<MenuItem value={option} key={id + "_" + index}>{option}</MenuItem>)
                    })}
                </Select>
            </FormControl>
        )
    }

    const handleSelectChange = (id, value) => {
        let o = {};
        o[id] = value;
        setImportTableDataField({...importTableDataField, ...o});
    }

    const importCsv = () => {
        document.getElementById("uploadDocSelect").click();
    }

    const selectFile = (event) => {
        const file = event.target.files[0];
        if(file) {
            readString(file, {
                header: true,
                complete: (result) => {
                    //console.log("result parse", result);
                    if(result.data && result.data.length > 0){
                        let options = Object.keys(result.data[0]);
                        let itdf = {};
                        tableFields.map((field) => {
                            let optionIndex = options.indexOf(field.display);
                            if(optionIndex > -1){
                                itdf[field.id] = field.display;
                            }
                        })
                        if(Object.keys(itdf).length > 0){
                            setImportTableDataField({...importTableDataField,...itdf});
                        }
                        //prepareImportDialogTable(options);
                        setImportTableData(result.data);
                        setImportTableHeaderOptions(options);
                        setImportDialogVisible(true);
                    }
                },
                error: (err) => {
                    dispatch(setSnackbar({type: "error", message: err}));
                    console.log(err);
                }
            });
        } else {
            dispatch(setSnackbar({type: "warning", message: t("No file selected")}));
        }
        //console.log("open selected file", event, event.target.files);
    }

    return (
        <span>
            <Button variant="outlined" className={props.btnIconClass} disabled={props.disabled} onClick={importCsv}><AgyleNamedIcon name="upload" className={props.iconClass}/></Button>
            <input id="uploadDocSelect" className={classes.hiddenInput} onChange={selectFile} type="file" accept=".csv"/>
            <Dialog open={importDialogVisible} onClose={handleCloseImportDialog} fullWidth={true} maxWidth={"xl"}>
                <DialogTitle>
                    {t("Import data")}&nbsp;<b>{tableDisplay}</b>
                </DialogTitle>
                <DialogContent>
                    <table className={classes.fullWidth}>
                        <thead>
                            <tr className={classes.header}>
                            {tableFields.map((field) => {
                                return (<th key={"header_" + field.id}>
                                    <div>{field.display}</div>
                                    <div>{prepareSelect(field.id)}</div>
                                </th>)
                            })}
                            </tr>
                        </thead>
                        <tbody className={classes.tableBody}>
                        {importTableData.map((row, index) => {
                            return (
                                <tr key={"row_"+index}>
                                    {tableFields.map((field) => {
                                        return (
                                            <td key={index + "_field_" + field.id}>
                                                {row[importTableDataField[field.id]]}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={tableFields.length}>
                                    {t("Total")}&nbsp;{importTableData.length}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseImportDialog}>
                        {t("Cancel")}
                    </Button>
                    <Button onClick={handleImport}>
                        {t("Import")}
                    </Button>
                </DialogActions>
            </Dialog>
        </span>
    )
}